<template>
  <modal
    :title="setModel.Name + ' Provider Hotel Codes'"
    @close="$emit('close')"
    :size="'xl'"
  >
    <template #content>
      <div
        v-if="data != null"
        class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
      >
        <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
          <button
            class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
            type="button"
            @click="addPopShow = true"
          >
            <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
            <span class="p-l-20 p-r-10">Add Hotel Codes</span>
          </button>
        </div>
      </div>
      <load-area v-if="data == null"></load-area>

      <dataTable
        :name="'CustomerProviderHotelCodes'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @update="updatePopShow = $event"
        @remove="remove"
        v-if="data != null"
      ></dataTable>
    </template>
  </modal>
  <upsert
    v-if="addPopShow || updatePopShow != null"
    :addId="setModel.Id"
    :setModel="updatePopShow"
    @add="$refs.agGrid.addRow([$event])"
    @update="$refs.agGrid.changeRow('Id', $event)"
    @close="
      addPopShow = false;
      updatePopShow = null;
    "
  ></upsert>
</template>

<script>
import upsert from "./upsert.vue";
export default {
  name: "hotelCodes",
  props: ["setModel"],
  components: { upsert },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 60,
        },
        {
          headerName: "HotelCode",
          field: "HotelCode",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 120,
        },
        {
          headerName: "HotelName",
          field: "HotelName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P1",
          field: "P1",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P2",
          field: "P2",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "P3",
          field: "P3",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "",
          type: "action",
          width: 75,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-pencil-alt"></i>',
              emit: "update",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      addPopShow: false,
      updatePopShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get("KOLAYREZ/CustomerProviderHotelCodes/" + this.setModel.Id)
      .then((response) => {
        this.data = response.data;
      });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text:
          "Are you sure you want to delete the hotel code named " +
          item.HotelName +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`KOLAYREZ/CustomerProviderHotelCodes/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Hotel code deleted successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
